import { render, staticRenderFns } from "./Consults.vue?vue&type=template&id=234033b5&scoped=true&"
import script from "./Consults.vue?vue&type=script&lang=js&"
export * from "./Consults.vue?vue&type=script&lang=js&"
import style0 from "./Consults.vue?vue&type=style&index=0&id=234033b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234033b5",
  null
  
)

export default component.exports